import { useEffect, useState } from "react";
import { isAdmin as fetchIsAdmin } from "@/utils/roles.functions";
import { useAuth } from "./useAuth";

export function useIsAdmin() {
  const { user, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setIsAdmin(false);
      setChecking(false);
      return;
    }
    let cancelled = false;
    setChecking(true);
    fetchIsAdmin()
      .then((r) => {
        if (!cancelled) setIsAdmin(r.isAdmin);
      })
      .catch(() => {
        if (!cancelled) setIsAdmin(false);
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.id, loading]);

  return { isAdmin, checking };
}
